/**
 * Desktop payment reminder daily cap (localStorage only).
 * Not used on web/Android — callers must guard with isDesktopApp().
 */

const PREFIX = 'payment_reminder_sent_v1';
export const PAYMENT_REMINDER_DAILY_LIMIT = 10;

export function getTodayKey() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function storageKey(companyId) {
  const id = companyId != null && String(companyId).trim() !== '' ? String(companyId) : '0';
  return `${PREFIX}_${id}_${getTodayKey()}`;
}

export function getSentCountToday(companyId) {
  if (typeof localStorage === 'undefined') return 0;
  const n = parseInt(localStorage.getItem(storageKey(companyId)) || '0', 10);
  if (!Number.isFinite(n) || n < 0) return 0;
  return n;
}

export function getRemainingReminderSends(companyId) {
  return Math.max(0, PAYMENT_REMINDER_DAILY_LIMIT - getSentCountToday(companyId));
}

export function incrementSuccessfulReminderSends(companyId, count = 1) {
  if (typeof localStorage === 'undefined' || !count || count < 1) return;
  const key = storageKey(companyId);
  const cur = getSentCountToday(companyId);
  localStorage.setItem(key, String(cur + count));
}
